import { InteractionStatus } from '@azure/msal-browser';

import { useAuthHandler } from '@auth/useAuthHandler';
import avatarImageUrl from '@images/avatar-background.png';
import mainBackgroundUrl from '@images/main-background.png';
import tomiLogoUrl from '@images/tomi-logo.png';
import LoadingScreen from '@components/LoadingScreen';
import { usePreloadImages } from '@hooks/usePreloadImages';

import { useGoogleAnalytics } from './features/google-analytics/hooks';
import AuthenticatedLayout from './layout/AuthenticatedLayout';

const App = () => {
    const { isAuthenticated, inProgress } = useAuthHandler();
    const areImagesLoaded = usePreloadImages([avatarImageUrl, mainBackgroundUrl, tomiLogoUrl]);
    useGoogleAnalytics();

    const isWebsiteReady =
        areImagesLoaded && isAuthenticated && inProgress === InteractionStatus.None;

    if (!isWebsiteReady) {
        return <LoadingScreen />;
    }

    return <AuthenticatedLayout />;
};

export default App;
